
import { useState, useEffect } from "react"

export const useGetWidh =()=>{

    const getCurrentDimension =()=>{
        return {
            width: window.innerWidth,
            height: window.innerHeight
        }
    }

    const [actualDimensions, setActualDimensions] = useState(getCurrentDimension());

    useEffect(()=>{
        const updtaeDimensions = ()=>{
            setActualDimensions(getCurrentDimension());
        }
        window.addEventListener('resize', updtaeDimensions);

        return (()=>{
            window.removeEventListener('resize', updtaeDimensions)
        })
    },[actualDimensions]);

    return{
        actualDimensions
    }

}